module.exports = __webpack_public_path__ + "img/zhinengjiaju6.33589fc6.jpg";